const OFFSET_STEP = 50;

export const getLeftToShow = (itemsCount: number, itemsOnScreen: number) =>
    Math.min(itemsCount - itemsOnScreen, OFFSET_STEP);
